import React from 'react';
import Jumbotron from '../components/Fragments/jumbotron';
import AboutSection from '../components/Fragments/about';
import ProjectSection from '../components/Fragments/projects';

const HomePage = () => {
      return (
        <div className="home" id = "home">
            <div className="parallax">
              <Jumbotron/>
              <AboutSection/>
              <ProjectSection/>
              <br />
              <p className="text-center">Copyright © {new Date().getFullYear()} Giovanni Abel Christian</p>
              <br />
            </div>
        </div>
        );

}

export default HomePage;